import apiClient from './apiClient';

const userService = {
  // Get all users (based on permissions)
  getUsers: async () => {
    const response = await apiClient.get('/users');
    return response.data;
  },
  
  // Get a single user
  getUser: async (userId) => {
    const response = await apiClient.get(`/users/${userId}`);
    return response.data;
  },
  
  // Create a new user
  createUser: async (data) => {
    const response = await apiClient.post('/users', data);
    return response.data;
  },
  
  // Update user
  updateUser: async (userId, data) => {
    const response = await apiClient.put(`/users/${userId}`, data);
    return response.data;
  },
  
  // Delete user
  deleteUser: async (userId) => {
    const response = await apiClient.delete(`/users/${userId}`);
    return response.data;
  },

  // Get company context for current user
  getCompanyContext: async () => {
    const response = await apiClient.get('/users/company-context');
    return response.data;
  },

  // Get permissions for current user
  getPermissions: async () => {
    const response = await apiClient.get('/users/permissions');
    return response.data;
  }
};

export default userService;